jQuery(function($){
	(function() {
		"use strict";

		function removePaypalNodes() {
			// Target block cart/checkout payment option containers
			let querySelector = '';
			const querySelectorArray = [
				'.wc-block-cart__payment-options',
				'.wc-block-checkout__payment-methods',
				'.wc-block-checkout__payment',
				'.wc-block-cart__payments',
				'.wc-block-checkout-express-payment',
				'.wc-block-checkout__express-payment-methods',
				'.wc-block-checkout__express-payment',
				'.wc-block-components-express-payment',
				'.wc-block-components-express-payment-continue-rule',
			];

			var containers = document.querySelectorAll(querySelectorArray.join(', '));
			if (!containers || containers.length === 0) return;

			containers.forEach(function(container) {
				// Remove nodes that explicitly identify PayPal by data attributes or common classes
				// (covers various plugin output variants)
				var paypalSelectors = [
					'[data-method="paypal"]',
					'[data-payment-method-id*="paypal"]',
					'.wc-paypal-payments__smart-button',
					'.paypal-smart-button',
					'.wc-paypal-smart-button',
					'.wc-paypal-payments',
					'.wc-block-components-express-payment',
					'.wc-block-components-express-payment-continue-rule',
				];

				paypalSelectors.forEach(function(sel) {
					console.log(sel)
					var nodes = container.querySelectorAll(sel);
					nodes.forEach(function(n) {
						n.remove();
					});
				});

				// Also remove any list item / radio label that contains the text "PayPal" (case-insensitive)
				// This is a fallback for markup variants.
				var textNodes = container.querySelectorAll('label, .wc-block-checkout__payment-method, .wc-block-cart__payment-method');
				textNodes.forEach(function(el) {
					if (el && el.textContent && /paypal/i.test(el.textContent)) {
						el.remove();
					}
				});

				// If the container is now empty (no payment options) hide it
				// (prevents leaving an empty payments block)
				var anyPaymentChildren = container.querySelector('[data-method], .wc-block-checkout__payment-method, input[name="payment_method"]');
				if (!anyPaymentChildren) {
					container.style.display = 'none';
				}
			});
		}

			console.log('test made it');
			// Run on DOM ready
			if (document.readyState === 'loading') {
				document.addEventListener('DOMContentLoaded', removePaypalNodes);
			} else {
				removePaypalNodes();
			}

			// Also run after a short delay (Blocks might render slightly later)
			setTimeout(removePaypalNodes, 2000);

			// Observe the body for dynamic changes (react re-renders, single-page updates, etc.)
			var observer = new MutationObserver(function() {
				removePaypalNodes();
			});
			observer.observe(document.body, { childList: true, subtree: true });

			// Optional: expose a method for debugging in the console
			window.__wc_blocks_force_remove_paypal = removePaypalNodes;
		if($('body').hasClass('woocommerce-cart') || $('body').hasClass('woocommerce-checkout')) {
		}
	})();
});